export default {
  setProductsHome(state, products) {
    state.productsHome = products || [];
  },
};
